import 'rxjs/Rx';
import {Component, OnDestroy, OnInit} from '@angular/core';
import {AppStateService, LoggerService, TakerAppState} from './modules/hbs-services';

@Component({
    selector: 'home-component',
    moduleId: module.id,
    templateUrl: './home.component.html'
})
export class HomeComponent implements OnInit, OnDestroy {

    constructor(private appStateService: AppStateService,
                private logger: LoggerService) {
    }

    ngOnInit() {

        this.logger.log('HomeComponent: ngOnInit:');

        // each main app calls to start apps initialization
        this.appStateService.emit(new TakerAppState('ui-ready'));

    }

    ngOnDestroy() {
    }

    outputAction(actionType: string): boolean {
        this.logger.log('HomeComponent: outputAction:', arguments);
        return false;
    }

}
